import { render, staticRenderFns } from "./CommentContent.vue?vue&type=template&id=4bbf9b4c&"
import script from "./CommentContent.vue?vue&type=script&lang=js&"
export * from "./CommentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports